import SectionHeading from '@/pages/home/components/SectionHeading';
import { riskChecklist } from '@/mocks/home';

export default function RisksSection() {
  return (
    <section id="risks" className="py-14 md:py-20 bg-foreground-950">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 text-xs font-medium tracking-wide text-primary-300 uppercase mb-3">
            <span className="w-6 h-px bg-primary-400"></span>
            风险提示
          </span>
          <h2 className="font-heading font-bold text-background-50 text-2xl md:text-3xl leading-snug">
            出现这些信号，请立刻停下来
          </h2>
          <p className="mt-3 text-background-300 leading-relaxed text-sm md:text-base">
            下面这份自检清单里的任意一条被触发，都意味着你很可能已经站在风险边缘。及时关闭页面，往往比事后补救更有效。
          </p>
        </div>

        <div className="mt-9 grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
          {riskChecklist.map((r, i) => (
            <div
              key={r}
              className="flex gap-4 p-4 md:p-5 rounded-lg bg-foreground-900 border border-foreground-800"
            >
              <span className="w-8 h-8 shrink-0 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-alert-line"></i>
              </span>
              <p className="text-sm text-background-200 leading-relaxed">{r}</p>
              <span className="ml-auto font-heading text-background-700 text-sm shrink-0">{String(i + 1).padStart(2, '0')}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}